import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  Renderer2,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { IDatepicker, DatepickerStyle } from '../../../base/src/abcDatepicker/abcDatepicker';
@Component({
  selector: '',
  template: `<div class="matDatepickerStyle">
    <mat-form-field #matDatepicker [class]="class">
      <mat-label>{{ placeholder }}</mat-label>
      <input
        matInput
        [matDatepicker]="picker"
        [(ngModel)]="value"
        disabled="{{ readOnly }}"
        id="{{ id }}"
        (ngModelChange)="dataChanged($event)"
      />
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
  </div>`,

  styleUrls: ['./matDatepicker.component.scss'],
})
export class MatDatepickerComponent implements IDatepicker, OnInit, AfterViewInit {
  @Input() id: string;
  @Input() placeholder?: string;
  @Input() value: any;
  @Input() symbol: string;
  @Input() class: string;
  readOnly: boolean = false;
  @Output() onChange: EventEmitter<any> = new EventEmitter();
  @ViewChild('matDatepicker', { static: true }) matDatepicker;

  constructor(private renderer2: Renderer2) {}
  ngOnInit() {}

  ngAfterViewInit() {
    if (this.class) {
      const element = this.matDatepicker._elementRef.nativeElement;
      this.renderer2.addClass(element, this.class);
    }
  }

  dataChanged(value) {
    this.onChange.emit(value);
  }

  setDatepickerStyle(style: DatepickerStyle) {
    const element = this.matDatepicker._elementRef.nativeElement;
    if (style) {
      for (let key in style) {
        element.style[key] = style[key];
      }
    }
  }

  setCustomDataAttributes(data: Object) {
    const element = this.matDatepicker._elementRef.nativeElement;
    if (data) {
      for (let key in data) {
        element.setAttribute(key, data[key]);
      }
    }
  }
  addEventListener(
    type: string,
    listener: EventListenerOrEventListenerObject,
    options?: boolean | AddEventListenerOptions
  ) {
    const element: HTMLElement = this.matDatepicker._elementRef.nativeElement;
    element.addEventListener(type, listener, options);
  }
}
